/* eslint-disable object-shorthand */

import { mapActions, mapGetters, mapState } from 'vuex';
import contentHeader from '@/components/generics/content-header/content-header.vue';
import { formMixin, validators } from '@/components/forms/mixin';
import loaderMixin from '@/mixins/loader';

export default {
  mixins: [
    loaderMixin,
    formMixin,
  ],
  components: {
    contentHeader,
  },
  validations: {
    fields: {
      newUserName: validators.username,
    },
  },
  data() {
    return {
      initialised: false,
      fields: {
        username: '',
        newUserName: '',
      },
    };
  },
  computed: {
    ...mapGetters('app', ['isLayoutDesktop']),
    ...mapState('user', ['userData', 'usernameTries']),
    isSubmitButtonDisabled() {
      return this.invalidOrDisabled || this.usernameTries === 0;
    },
    isUsernameInputDisabled() {
      return this.isFormDisabled || this.usernameTries === 0;
    },
  },
  watch: {
    isLoading(value) {
      const el = document.querySelector('.modal__body--show-ready');
      if (!el) return;
      if (value) {
        el.style.display = 'none';
      } else {
        el.style.display = 'block';
      }
    },
    userData: {
      handler: 'userDataChanged',
      immediate: true,
    },
  },
  methods: {
    ...mapActions('notifications', ['setSuccessSideNotificationWithTimeoutCallback']),
    ...mapActions('user', ['changeUserName', 'getAccountDetail', 'getUserNameTries']),
    userDataChanged(value) {
      if (value) {
        this.fields.username = value.userName;
      }
    },
    onSubmit() {
      if (this.formIsValid() && this.formDisable()) {
        this.changeUserName(this.fields.newUserName)
        .then(() => {
          this.setSuccessSideNotificationWithTimeoutCallback({
            text: 'Username Updated.',
            callback: () => this.$router.go(-1),
          });
        })
        .then(this.formEnable)
        .then(this.getAccountDetail)
        .catch((e) => {
          this.formHandleErrors(e);
        });
      }
    },
  },
  mounted() {
    this.loaderAdd(document.body);
    this.getUserNameTries()
      .then((data) => {
        this.loaderRemove(document.body);
        this.initialised = true;
        this.$nextTick(() => {
          if (data > 0) {
            const newUsernameInput = this.$refs.newUsername.$el.querySelector('.input__value');
            newUsernameInput.focus();
          }
        });
      });
  },
};



// WEBPACK FOOTER //
// ./src/components/account/account-details/update/account-details-update.js